import { render, staticRenderFns } from "./AdyenOrderPaymentForm.vue?vue&type=template&id=5510eb4a"
import script from "./AdyenOrderPaymentForm.vue?vue&type=script&lang=js"
export * from "./AdyenOrderPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports